"use strict";
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, find} from "../libs/@elements/dom-utils";

export function init () {
    onFind('.js-toggle-open', function (item) {
        on('click', function () {
            let target = find(item.getAttribute('data-target'));

            if (hasClass('is-open', target)) {
                removeClass('is-open', target);
            } else {
                addClass('is-open', target);
            }

        }, item);
    });
}
